<template>
  <div>
    <add-or-update-lab-modal
      :is-add-active.sync="toggleModal"
      resource="labs"
      @create="onCreate"
      @update="onUpdate"
      @refetchData="fetchLabTypes"
    />

    <div class="d-flex align-content-between align-items-start">
      <v-select 
        v-model="lab_type_ids" 
        class="flex-grow-1"
        :options="labTypes" 
        :close-on-select="false" 
        :reduce="val => val.id" 
        dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="name"
        multiple 
        clearable 
        @input="onOptionSelected"
      >
      </v-select>

      <div v-if="can('lab_types:CanAddNew')">
        <b-button size="sm" variant="no-outline" @click="onAddNew">
          <feather-icon icon="PlusCircleIcon" size="25" color="dodgerblue"></feather-icon>
        </b-button>
      </div>
    </div>
  </div>
</template>
  
<script>
import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import AddOrUpdateLabModal from '@/@core/components/shared/admin/modals/AddOrUpdateLabModal.vue'
  
export default {
  components: {
    vSelect,
    BButton,
    AddOrUpdateLabModal

  },
  props: {
    categoryId: {
      required: false,
      default: "",
      type: String,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,

      labTypes: [{}],
      lab_type_ids: [],
    }
  },
  created() {
    this.fetchLabTypes();
  },
  methods: {
    async fetchLabTypes(category_id) {
      try {
        this.loading = true; 

        const query = {
          page: 1,
          limit: 50,
          search: category_id || this.value,
          category_id: this.categoryId
        }
        
        const request = await this.useJwt().mainService.labTypes.list(query);
        const { data } = request.data;
        this.labTypes = data
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async onCreate(form_data){
      try {
        this.loading = true;

        const result = await this.$swal({
          title: "Caution!!!",
          text: `Proceed to add new record?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: 'Yes',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.isConfirmed) {
          return;
        }

        const { payload, save_and_new } = form_data;
        await this.useJwt().mainService.labTypes.create(payload);
        this.fetchLabTypes();

        if (save_and_new){
          this.toggleModal = false;
          setTimeout(() => {
            this.toggleModal = true;
          }, 100)
        } else {
          this.toggleModal = false;
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Record added successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async onUpdate(form_data){
      try {
        this.loading = true;

        const result = await this.$swal({
          title: "Caution!!!",
          text: `Proceed to update record?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: 'Yes',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.isConfirmed) {
          return;
        }

        const { id, payload } = form_data;
        await this.useJwt().mainService.labTypes.update(id, payload);
        this.toggleModal = false;

        this.fetchLabTypes();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Record updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    onAddNew(){
      this.toggleModal = true;
    },
    onOptionSelected(selected_option) {
      this.$emit('change', selected_option)
    },
  }
}
</script>
